<div class="mat-mdc-dialog-surface mdc-dialog__surface" style="background: #EAEEF4;">

    <h2 mat-dialog-title style="background: white;">
        Log Hours
        <button class="close-button" (click)="onCancel()" disableRipple>
            <span class="material-symbols-outlined">close</span>
        </button>
    </h2>

    <mat-dialog-content class="mat-typography custom-dialog">
        <div class="training-form">
            <div class="form-field">
                <label>Training Name</label>
                <input
                    type="text"
                    [(ngModel)]="summaryDetails.trainingName"
                    disabled
                />
            </div>

            <div class="form-field">
                <label>{{isMentor ? 'Mentee' : 'Mentor'}}</label>
                <input
                    type="text"
                    [(ngModel)]="isMentor ? summaryDetails.menteeName : summaryDetails.mentorName"
                    disabled
                />
            </div>

            <ng-container *ngIf="isMentor">            
                <div class="form-field">
                    <label>Mentor Hours</label>
                    <input
                        type="number"
                        class="no-spinner"
                        step="0.01"
                        min="0"
                        [(ngModel)]="summaryDetails.mentorHours"
                    />
                </div>
            </ng-container>

            <ng-container *ngIf="!isMentor">
                <div class="form-field">
                    <label>Mentoring Hours</label>
                    <input
                        type="number"
                        class="no-spinner"
                        step="0.01"
                        min="0"
                        [(ngModel)]="summaryDetails.hoursSpent"
                    />
                </div>
            </ng-container>


            <div class="form-field percent-input">
                <label>% Completed</label>
                <input
                    type="number"
                    [(ngModel)]="summaryDetails.completedPercentage"
                    (input)="percentage = $event.target.value"
                    class="no-spinner"
                    [disabled]="!isMentor"
                />
            </div>

            <div class="form-field">
                <label>Status</label>
                <select [(ngModel)]="summaryDetails.status" [disabled]="!isMentor">
                    <option
                        class="status-option"
                        *ngFor="let status of statusOptions"
                        [value]="status"
                    >{{status}}</option>
                </select>
            </div>

            <div class="form-field">
                <label>Start Date</label>
                <input
                    type="date"
                    [(ngModel)]="summaryDetails.startDate"
                    disabled
                />
            </div>

            <div class="form-field">
                <label>End Date</label>
                <input
                    type="date"
                    [(ngModel)]="summaryDetails.endDate"
                    disabled
                />
            </div>
        </div>

    </mat-dialog-content>

    <mat-dialog-actions class="review">
        <button class="btn btn-outline btn-spacing" (click)="onCancel()">
            Cancel
        </button>

        <button (click)="updateTraining()" class="btn btn-primary">
            Update
        </button>
    </mat-dialog-actions>
</div>

<ng-template #filterTemplate let-head="head" let-options="options">
    <div>
        <span
            class="material-symbols-outlined filter-icon"
            (click)="openCloseFilter(head.Name)"
        >
            filter_alt
        </span>
    </div>
    <div
        class="filter-container"
        tabindex="1"
        *ngIf="filterColumns[head.Name]"
    >
        <div>
            <span
                class="material-symbols-outlined clearIcon"
                (click)="openCloseFilter(head.Name)"
            >
                close
            </span>
        </div>
        <input
            #input
            type="text"
            mat-input
            (input)="searchOptions(input.value,head.Name)"
            class="form-control search-Text"
            placeholder="Search {{head.Name}}"
        />
        <div class="filterOptions" *ngFor="let option of options">
            <mat-checkbox
                class="check-box"
                [(ngModel)]="option.isChecked"
                (ngModelChange)="onOptionChange($event, option, head.Name)"
            >{{option.name}}</mat-checkbox>
        </div>
    </div>
</ng-template>